import { useState } from 'react';

import { FiltroTransacoes } from '../../../models/FiltroTransacoes.model';
import {
  TIPO_TRANSACAO_PF,
  TIPO_TRANSACAO_PJ,
  TIPO_TRANSACAO_PJ_USER
} from '../../../models/Transacao.model';
import FilterDrawer from '../../components/FilterDrawer';

import FiltrarTransacoes from './FiltrarTransacoes';

type TipoTransacao =
  | typeof TIPO_TRANSACAO_PF
  | typeof TIPO_TRANSACAO_PJ
  | typeof TIPO_TRANSACAO_PJ_USER;
interface Props {
  open: boolean;
  onClose: (data: FiltroTransacoes) => void;
  onCancel: () => void;
  permitirFiltrarUsuarios?: boolean;
  tipoTransacoes: TipoTransacao;
  tab: number;
}

const DrawerFiltrarTransacao = ({
  open,
  onClose,
  onCancel,
  tipoTransacoes,
  permitirFiltrarUsuarios = false,
  tab
}: Props) => {
  const [filtroTransacao, setFiltroTransacao] = useState<FiltroTransacoes>({});

  const onCloseDrawer = (filtroTransacao: FiltroTransacoes) => {
    setFiltroTransacao(filtroTransacao);
    onClose(filtroTransacao);
  };

  const tiposTransacaoSelect = Object.entries(tipoTransacoes).map(([key, value]) => ({
    label: key,
    value
  }));

  return (
    <FilterDrawer
      title={permitirFiltrarUsuarios ? 'Filtrar transações de usuários' : 'Filtrar transações'}
      subtitle="Encontre transações usando os filtros abaixo."
      open={open}
      onCancel={onCancel}
    >
      <FiltrarTransacoes
        tiposTransacao={tiposTransacaoSelect}
        filtroTransacoes={filtroTransacao}
        onClose={onCloseDrawer}
        permitirFiltrarUsuarios={permitirFiltrarUsuarios}
        tab={tab}
      />
    </FilterDrawer>
  );
};

export default DrawerFiltrarTransacao;
